import { render, staticRenderFns } from "./WindowType.vue?vue&type=template&id=52a93cf2"
import script from "./WindowType.vue?vue&type=script&lang=ts"
export * from "./WindowType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports